module.exports = __webpack_public_path__ + "media/images/app/products/index/categories/bracelets-b544b8d57958699c623ff1fd8227bf61.webp";